<template>
  <form class="nx-form nx-relation-card" :class="{ 'nx-active': active }" :data-vv-scope="scope">
      <v-progress-linear
        v-show="loading"
        indeterminate
        background-opacity="0"
        height="2"
      />

      <v-layout class="row wrap px-3">
        <v-flex class="xs12">
          <nx-content-form-selector
            :id="`form-field-${scope}-destContent`"
            :disabled="loading || disabled"
            :label="$t('message.form.fields.contentId')"
            :allowNonPublished="allowNonPublished"
            :excluded-content-ids="excludedEntityIds"
            :type="types"
            :value="draft.destContent"
            :open-modal-editor="openModalEditor"
            name="destContent"
            validation="required"
          />
        </v-flex>

        <v-flex class="xs12 md6">
          <nx-clipping-form-selector
            :id="`form-field-${scope}-clipping`"
            :allow-only-source-aspect-ratio="allowOnlySourceAspectRatio"
            :additional-filters="clippingSelectorAdditionalFilters"
            :aspect-ratios="aspectRatios"
            :before-create-clipping-aliases="beforeCreateClippingAliases"
            :disabled="loading || disabled"
            :disable-crop="disableCrop"
            :label="$t('message.form.fields.clippingId')"
            :title-length="7"
            :type="clippingTypes"
            :value="draft.clipping"
            name="clipping"
            :validation="{required: clippingRequired}"
          />
        </v-flex>

        <v-flex class="xs12 md6" :class="{'pl-3': $vuetify.breakpoint.mdAndUp }">
          <component
            :is="textComponent"
            :id="`form-field-${scope}-title`"
            name="title"
            :disabled="loading || disabled"
            :label="$t('message.form.fields.title')"
            :value="draft.title"
            v-validate="draft.destContent ? 'required' : ''"
            v-bind="textComponentProps"
          />

          <nx-taxonomy-form-selector
            :id="`form-field-${scope}-kicker`"
            :disabled="loading || disabled"
            :label="$t('message.form.fields.kicker')"
            :limit="1"
            :type="['microsite','section']"
            name="kicker"
            v-model="draft.kicker"
            :validation="{required: kickerRequired}"
          />
          <nx-taxonomy-form-selector
            :id="`form-field-${scope}-author`"
            :disabled="loading || disabled"
            :label="$t('message.form.fields.author')"
            :limit="1"
            :type="['author']"
            name="author"
            v-model="draft.author"
            :validation="{required: authorRequired}"
          />
        </v-flex>
      </v-layout>
  </form>
</template>

<script>
import { getMediaTypes } from '@/modules/content/config';
import RelationCardForm from '@/modules/relation/card/form/RelationCardForm';
import NxClippingFormSelector from '@/modules/clipping/form/Selector';
import NxTaxonomyFormSelector from '@/modules/taxonomy/selector/FormSelector';

export default {
  name: 'nx-relation-content-card-form',
  components: {
    NxClippingFormSelector,
    NxTaxonomyFormSelector,
  },
  extends: RelationCardForm,
  props: {
    clippingTypes: {
      type: Array,
      default: getMediaTypes(),
    },
    authorRequired: {
      type: Boolean,
      default: false,
    },
    kickerRequired: {
      type: Boolean,
      default: false,
    },
    clippingRequired: {
      type: Boolean,
      default: false,
    },
    excludedEntityIds: {
      type: Array,
      default: () => ([]),
    },
    aspectRatios: {
      type: Array,
      default: () => ['source-aspect-ratio'],
    },
    allowOnlySourceAspectRatio: Boolean,
  },
};
</script>
